
<template>
  <v-container class="px-6 px-sm-12">
    <PageHeader :header-text="'Vessel Overview'" :header-icon="'mdi-eye'" />

    <div class="d-flex mb-4">
      <VorButton v-if="vorURL" :url="vorURL" />

      <v-spacer />

      <h3 v-if="!loading" class="text-end font-weight-bold mb-4">
        Last Refresh At (LT):
        {{ overviewReport.refreshedAtLt | removeTAndDateAndSeconds }}
      </h3>
    </div>

    <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
    <div v-else-if="vesselReports && vesselReports.length > 0">
      <v-row dense>
        <v-col
          v-for="rpt in vesselReports"
          :key="rpt.vesselName"
          cols="12"
          xl="3"
          lg="4"
          md="6"
        >
          <VesselOverviewCard
            :report="rpt"
            :overdueHours="overviewReport.overdueHours"
            :lastRefreshLt="overviewReport.refreshedAtLt"
          />
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-row justify="center">
        <InfoAlert message="No active voyages found for site" />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ResponsiveSizeHelperMixin from '../mixins/ResponsiveSizeHelperMixin';
import PageHeader from '../components/ui/PageHeader.vue';
import VesselOverviewCard from '../components/vessel-overview/VesselOverviewCard.vue';
import InfoAlert from '../components/ui/InfoAlert.vue';
import VorButton from '../components/ui/VorButton.vue';

export default {
  name: 'VesselOverview',
  components: {
    PageHeader,
    VesselOverviewCard,
    InfoAlert,
    VorButton,
  },
  mixins: [ResponsiveSizeHelperMixin],
  data() {
    return {
      loading: false,
      updateTimer: '',
      cards: [
        { title: 'Halul 81', flex: 4, src: 'https://photos.marinetraffic.com/ais/showphoto.aspx?shipid=2893136&size=thumb600' },
        { title: 'Halul 20', flex: 4, src: 'https://media.glassdoor.com/l/fe/03/b4/98/offshore-services-vessel.jpg' },
        { title: 'Halul 22', flex: 4, src: 'https://docplayer.net/docs-images/62/47306244/images/10-2.jpg' },
        { title: 'FOG 11', flex: 4, src: 'https://www.firstoilandgas.com/wp-content/uploads/2018/07/fog-11-slider.jpg' },
        { title: 'Halul 60', flex: 4, src: 'https://www.milaha.com/wp-content/uploads/Halul-60.jpg' },
      ],
    };
  },
  computed: {
    ...mapState(['overviewStore', 'userStore']),
    ...mapGetters({
      getActiveSite: 'userStore/getActiveSite',
      vorURL: 'userStore/getVorVesselOverviewUrl',
    }),
    activeSiteId() {
      const site = this.getActiveSite;
      if (!site) {
        return null;
      }
      return site.id;
    },
    overviewReport() {
      return this.overviewStore
        ? this.overviewStore.overviewReport : null;
    },
    vesselReports() {
      const reports = (this.overviewReport && this.overviewReport.vesselReports) || [];
      const reportsWithAtLeastOneActivity = reports.filter((x) => x.vesselActivities.length > 0);
      return reportsWithAtLeastOneActivity;
    },
  },
  watch: {
    activeSiteId(newVal) {
      this.loadOverViewReport();
    },
  },
  created() {
    this.loadOverViewReport();
    this.updateTimer = setInterval(this.loadOverViewReport, 120000);
  },
  methods: {
    loadOverViewReport() {
      this.loading = true;
      this.$store.dispatch('overviewStore/loadOverviewReport', this.activeSiteId)
        .finally(() => {
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.updateTimer);
  },
};
</script>
